'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WoodOilCombinationIcon = function WoodOilCombinationIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M79.788 70.16V0H0v70.16'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M25 28h79v70H25z'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M15 99h100v-2H15zM15 104h100v-2H15z'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    stroke: '#555',
                    transform: 'translate(25 27)'
                },
                _react2.default.createElement('path', {
                    d: 'M74.145 66.884H7.68a.917.917 0 0 1-.856-.586.917.917 0 0 1 .243-1.01l64.696-58.35H6.56v47.258H4.73V6.022c0-.505.41-.915.916-.915h68.499a.915.915 0 0 1 .612 1.595L10.061 65.053H73.23v-46.99h1.831v47.906c0 .505-.41.915-.915.915',
                    strokeWidth: '.3',
                    fill: '#555'
                }),
                _react2.default.createElement('path', {
                    d: 'M23.782 15.486c-2.333 3.502-6.775 10.77-6.775 13.703 0 3.733 3.039 6.772 6.775 6.772s6.775-3.039 6.775-6.772c0-2.933-4.441-10.202-6.775-13.703m0 21.94c-4.543 0-8.239-3.696-8.239-8.237 0-4.322 7.324-14.973 7.636-15.424l.603-.872.603.872c.311.45 7.636 11.102 7.636 15.424 0 4.541-3.695 8.236-8.24 8.236M60.403 57.612a2.736 2.736 0 0 0 3.86 0c.516-.516.799-1.2.799-1.93 0-.729-.283-1.414-.799-1.929L49.79 39.283a2.735 2.735 0 0 0-3.86 0 2.717 2.717 0 0 0-.8 1.93c0 .729.285 1.413.8 1.93l14.474 14.47zm1.93 2.161c-1.047 0-2.097-.4-2.894-1.197l-14.475-14.47a4.06 4.06 0 0 1-1.2-2.893c0-1.093.426-2.12 1.2-2.894a4.1 4.1 0 0 1 5.79 0l14.474 14.47c.774.773 1.2 1.8 1.2 2.893 0 1.092-.426 2.12-1.2 2.894a4.086 4.086 0 0 1-2.895 1.197z',
                    strokeWidth: '.576',
                    fill: '#555'
                }),
                _react2.default.createElement('path', {
                    d: 'M59.634 58.772a4.063 4.063 0 0 1-1.199-2.894c0-1.094.425-2.12 1.2-2.894a4.1 4.1 0 0 1 5.788 0l-.964.964a2.736 2.736 0 0 0-3.86 0 2.713 2.713 0 0 0-.799 1.93c0 .729.283 1.413.799 1.928l-.965.966zM47.858 59.774a4.081 4.081 0 0 1-2.894-1.196 4.076 4.076 0 0 1-1.2-2.896 4.07 4.07 0 0 1 1.2-2.893l4.735-4.734.966.964-4.735 4.735c-.517.515-.8 1.2-.8 1.928 0 .73.283 1.415.8 1.93 1.031 1.03 2.827 1.03 3.86 0l4.738-4.735.964.964-4.738 4.736a4.081 4.081 0 0 1-2.896 1.197M60.521 48.812l-.964-.964 4.706-4.705a2.73 2.73 0 0 0 0-3.86c-1.032-1.029-2.829-1.029-3.86 0l-4.621 4.621-.966-.964 4.62-4.621a4.077 4.077 0 0 1 2.896-1.199c1.095 0 2.123.427 2.895 1.199a4.097 4.097 0 0 1 0 5.789l-4.706 4.704z',
                    strokeWidth: '.576',
                    fill: '#555'
                }),
                _react2.default.createElement('path', {
                    d: 'M50.559 58.773l-.965-.965a2.73 2.73 0 0 0 0-3.858c-1.032-1.032-2.828-1.032-3.861 0l-.965-.965c.774-.774 1.801-1.2 2.895-1.2s2.122.426 2.896 1.2a4.098 4.098 0 0 1 0 5.788',
                    strokeWidth: '.576',
                    fill: '#555'
                }),
                _react2.default.createElement('use', {
                    strokeWidth: '.3',
                    xlinkHref: '#a'
                }),
                _react2.default.createElement('path', {
                    strokeWidth: '.3',
                    fill: '#555',
                    d: 'M4.73 58.731h1.83v-1.44H4.73zM73.229 14.623h1.83v-1.44h-1.83z'
                }),
                _react2.default.createElement('path', {
                    d: 'M77.957 70.16V1.83H1.83v68.33m77.957 0V0H0v70.16',
                    strokeWidth: '.3',
                    fill: '#555'
                })
            )
        )
    );
};

WoodOilCombinationIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var WoodOilCombination = function (_React$Component) {
    _inherits(WoodOilCombination, _React$Component);

    function WoodOilCombination() {
        _classCallCheck(this, WoodOilCombination);

        return _possibleConstructorReturn(this, (WoodOilCombination.__proto__ || Object.getPrototypeOf(WoodOilCombination)).apply(this, arguments));
    }

    _createClass(WoodOilCombination, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(WoodOilCombinationIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return WoodOilCombination;
}(_react2.default.Component);

exports.default = WoodOilCombination;